// @generated by protoc-gen-es v1.6.0 with parameter "target=js"
// @generated from file dymensionxyz/dymension/gamm/v1beta1/tx_swap.proto (package dymensionxyz.dymension.gamm.v1beta1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { SwapAmountInRoute, SwapAmountOutRoute } from "../../poolmanager/proto/swap_route_pb.js";
import { Coin } from "./coin_pb";

/**
 * ===================== MsgSwapExactAmountIn
 *
 * @generated from message dymensionxyz.dymension.gamm.v1beta1.MsgSwapExactAmountIn
 */
export const MsgSwapExactAmountIn = proto3.makeMessageType(
  "dymensionxyz.dymension.gamm.v1beta1.MsgSwapExactAmountIn",
  () => [
    { no: 1, name: "sender", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "routes", kind: "message", T: SwapAmountInRoute, repeated: true },
    { no: 3, name: "token_in", kind: "message", T: Coin },
    { no: 4, name: "token_out_min_amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.gamm.v1beta1.MsgSwapExactAmountInResponse
 */
export const MsgSwapExactAmountInResponse = proto3.makeMessageType(
  "dymensionxyz.dymension.gamm.v1beta1.MsgSwapExactAmountInResponse",
  () => [
    { no: 1, name: "token_out_amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.gamm.v1beta1.MsgSwapExactAmountOut
 */
export const MsgSwapExactAmountOut = proto3.makeMessageType(
  "dymensionxyz.dymension.gamm.v1beta1.MsgSwapExactAmountOut",
  () => [
    { no: 1, name: "sender", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "routes", kind: "message", T: SwapAmountOutRoute, repeated: true },
    { no: 3, name: "token_in_max_amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "token_out", kind: "message", T: Coin },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.gamm.v1beta1.MsgSwapExactAmountOutResponse
 */
export const MsgSwapExactAmountOutResponse = proto3.makeMessageType(
  "dymensionxyz.dymension.gamm.v1beta1.MsgSwapExactAmountOutResponse",
  () => [
    { no: 1, name: "token_in_amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

